import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
    Typography,
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { SharepointItem } from '../../../../shared/types/sharepoint';
import {
    listItemBaseSx,
    selectedItemSx,
} from '../../../../shared/styles/components/listItemStyles';

interface FileListProps {
    items: SharepointItem[];
    selectedItems: SharepointItem[];
    onItemClick: (item: SharepointItem) => void;
    onToggleSelect: (item: SharepointItem) => void;
}

export const FileList = ({
    items,
    selectedItems,
    onItemClick,
    onToggleSelect,
}: FileListProps) => {
    if (items.length === 0) {
        return (
            <Typography
                sx={{
                    textAlign: 'center',
                    color: 'text.secondary',
                    p: 2,
                }}
            >
                No hay elementos para mostrar
            </Typography>
        );
    }

    return (
        <List dense sx={{ maxHeight: 320, overflowY: 'auto' }}>
            {items.map((item) => {
                const selected = selectedItems.some((f) => f.id === item.id);
                return (
                    <ListItem
                        key={item.id}
                        onClick={() => onItemClick(item)}
                        sx={selected ? selectedItemSx : listItemBaseSx}
                    >
                        <Checkbox
                            checked={selected}
                            onClick={(e) => {
                                e.stopPropagation();
                                onToggleSelect(item);
                            }}
                            size="small"
                            sx={{ mr: 1 }}
                        />
                        <ListItemIcon>
                            {item.folder || item.isDrive ? (
                                <FolderIcon />
                            ) : (
                                <InsertDriveFileIcon />
                            )}
                        </ListItemIcon>
                        <ListItemText primary={item.name} />
                    </ListItem>
                );
            })}
        </List>
    );
};
